import React, { useState, useEffect } from "react";
import axios from "axios";
import "./EventGrid1.css"; // Assuming you reuse the same styling
import NavbarAll from "../Navbar/NavbarAll";
import { Link } from "react-router-dom";
const AllEvents = () => {
  const [events, setEvents] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;
  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get(`${apiUrl}/events`);
        setEvents(response.data);
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };

    fetchEvents();
  }, []);

  return (
    <>
    <NavbarAll />
    <div className="event-grid-container">
      <h2>All Events</h2>
      <div className="event-grid">
        {events.map((event) => (
          <div key={event.id} className="event-card">
            <img
              src={event.imageUrl}
              alt={event.title}
              className="event-image"
            />
            <h3>{event.title}</h3>
            <p>{new Date(event.date).toLocaleString()}</p>
            <Link to={`/events/${event.id}`} className="register-link">
  View Details
</Link>
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

export default AllEvents;
